<template>
  <article id="launch-modal-StickyNote">
    <div
      class="modal is-large"
      v-bind:class="{ 'is-active': isActiveFlightNote }"
    >
      <div @click="hideFlightNoteModal" class="modal-background"></div>

      <div
        class="modal-content animate__animated animate__zoomIn animate__faster"
      >
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <h2 class="modal-title">{{headerFlightText}} - Flight Notes</h2>
            </div>
            <button class="close-btn" @click="hideFlightNoteModal">
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

        <section class="modal-card-body is-large">
          <div
            v-if="user.permissions.includes('Schedule.FlightNoteAdd')"
            style="display: flex; flex-direction: column"
          >
            <textarea
              cols="10"
              rows="8"
              style="resize: none"
              v-model="writtenFlightNote"
              class="textarea"
              placeholder="You can write your message here…"
            ></textarea>
            <button
              style="margin: 20px 0; align-self: flex-end"
              class="message-button"
              @click="SendFlightNote(writtenFlightNote)"
              type="button"
            >
              Add Message
            </button>
          </div>

          <div
            v-if="FlightNoteList && FlightNoteList.length != 0"
            class="column"
          >
            <ul
              v-for="(Notes, index) in FlightNoteList.filter(
                (x) => x.ntype == 'N'
              )"
              :key="index"
            >
              <article
                v-if="EditableFlightNoteId == Notes.id"
                class="message"
                style="margin-bottom: 5px"
              >
                <div class="message-body">
                  <small>{{ Notes.whenDid | longFormatFromDT }} </small>
                  <strong>{{ Notes.whoDidFullName }} : </strong>
                </div>
                <textarea
                  cols="20"
                  rows="2"
                  style="resize: none"
                  v-model="Notes.message"
                  class="textarea"
                ></textarea>

                <button
                  class="button is-small is-primary"
                  @click="EditFlightNote(Notes)"
                >
                  Save
                </button>
                <button
                  class="button is-small is-danger"
                  @click="CloseEditableFlightNote()"
                >
                  Cancel
                </button>
              </article>

              <article v-else class="message" style="margin-bottom: 5px">
                <div class="message-body">
                  <small>{{ Notes.whenDid | longFormatDateFromString }} </small>
                  <strong>{{ Notes.whoDidFullName }} : </strong>
                  <pre
                    style="
                      background-color: #f5f5f5;
                      font-family: Consolas;
                      font-size: 16px;
                    "
                  >
 {{ Notes.message }} </pre
                  >
                </div>

                <button
                  v-if="user.email == Notes.whoDidEmail"
                  class="button is-small is-warning"
                  type="button"
                  @click="DeleteNote(Notes)"
                >
                  <font-awesome-icon icon="box" />
                  <span style="margin: 4px">Delete</span>
                </button>

                <button
                  v-if="user.email == Notes.whoDidEmail"
                  class="button is-small is-primary"
                  type="button"
                  @click="MakeEditableFlightNote(Notes)"
                >
                  <font-awesome-icon icon="edit" />
                  <span style="margin: 4px">Edit</span>
                </button>
              </article>
            </ul>
          </div>

          <div v-else style="margin-bottom: 7px">
            <p>There are no Notes for this flight.</p>
          </div>
        </section>
      </div>
    </div>
  </article>
</template>

<script>
import { loadingMixin } from "../../../utils/mixins";
import ScheduleService from "../../../services/schedule.service";
import { mapState, mapActions } from "vuex";

export default {
  name: "FlightNoteModal",
  mixins: [loadingMixin],

  props: ["activeLegNo", "headerFlightText"],

  data() {
    return {
      FlightNoteForm: {
        ID: 0,
        LEG_NO: 0,
        Message: "",
      },
      EditableFlightNoteId: null,
      EditFlightNoteForm: {
        ID: 0,
        LEG_NO: 0,
        Message: "",
      },
      writtenFlightNote: "",
      flightNoteActiveLegNo: "",
    };
  },

  computed: {
    ...mapState("schedule", [
      "isActiveFlightNote",
      "ActiveFlightNotes",
      "FlightNoteList",
      "SearchDate",
      "flightList",
    ]),

    ...mapState("auth", ["user"]),

    activeFKEYFORZIP: {
      get() {
        if (!this.flightList || !this.activeLegNo) {
          return "";
        }

        const flight = this.flightList.find(
          (x) => x.leG_NO == this.activeLegNo
        );

        if (!flight || !flight.fKeyForZip) {
          return "";
        }

        return flight.fKeyForZip;
      },
    },
  },

  methods: {
    ...mapActions("schedule", [
      "showFlightNoteModal",
      "closeFlightNoteModal",
      "GetFlightNotes",
      "getScheduleFlights",
    ]),

    async ManipulateNoteCNT() {
      this.flightList.find((x) => x.leG_NO == this.activeLegNo).notE_CNT =
        this.FlightNoteList.length - 1;
    },

    async DeleteNote(FlightNote) {
      console.log("test DeleteNote");
      await this.$swal({
        title:
          '<p style="text-align: left;font-size: 22px;">Do you want to delete flight note?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: "No",
        cancelButtonColor: "#C5381A",
        confirmButtonColor: "#1874DA",
        confirmButtonText: "Yes",
      }).then(async (response) => {
        if (response.value) {
          var respmessage = await ScheduleService.DeleteFlightNoteForm(
            FlightNote
          );

          if (respmessage == 1) {
            // this.$notify({
            //     title: "Success",
            //     text:  "Note Successfully Deleted. " +respmessage ,
            //     type: "success"
            // });
          } else {
            //this.$notify({title: "Error", text: "Error occured while delete Note", type: "error"});
          }

          await this.GetFlightNotes(this.activeLegNo);

          // await this.GetFlightNotes(this.activeLegNo);

          this.ManipulateNoteCNT();

          // this.$notify({
          //     title: "Success",
          //     text: "FlightNote is deleted.",
          //     type: "success"
          // });
        }
      });
    },

    async SendFlightNote(writtenFlightNote) {
      try {
        console.log("test SendFlightNote");
        this.FlightNoteForm.Message = writtenFlightNote;
        this.FlightNoteForm.LEG_NO = this.activeLegNo;
        let respmessage = await ScheduleService.InsertOrUpdateFlightNoteForm(
          this.FlightNoteForm
        );

        if (respmessage == 1) {
          // bu kısımda netline message note un silinmesi. text kutusunda ...
          // this.$notify({
          //     title: "Success",
          //     text:  "Note Successfully Added. " +respmessage ,
          //     type: "success"
          // });
        } else {
          //this.$notify({title: "Error", text: "Error occured while Insert Note", type: "error"});
        }

        try {
          await this.GetFlightNotes(this.activeLegNo);
          this.FlightNotifyDetails = JSON.parse(
            this.FlightNoteList.filter((x) => x.ntype == "T")[0].message
          );
        } catch (e) {
          console.log();
        }

        // this.FlightNotifyDetails = this.FlightNoteList.filter(x=>x.ntype == "T")
        // await this.GetFlightNotes(this.activeLegNo);
        this.writtenFlightNote = "";

        this.ManipulateNoteCNT();
      } catch (e) {
        //this.$notify({title: "Error", text:"Error on SendFlightNote function e: "+ e.message, type: "error"});
      }
    },

    async MakeEditableFlightNote(EditableFlightNoteForm) {
      console.log(EditableFlightNoteForm);
      this.EditableFlightNoteId = EditableFlightNoteForm.id;
    },

    async CloseEditableFlightNote() {
      this.EditableFlightNoteId = null;
    },

    async EditFlightNote(FlightNoteForm) {
      console.log("test EditFlightNote");
      let respmessage = await ScheduleService.InsertOrUpdateFlightNoteForm(
        FlightNoteForm
      );

      if (respmessage == 1) {
        if (respmessage == 1) {
          // this.$notify({
          //     title: "Success",
          //     text:  "Note Successfully Added. " +respmessage ,
          //     type: "success"
          // });

          this.EditableFlightNoteId = null;
        } else {
          //this.$notify({title: "Error", text: "Error occured while Insert Note", type: "error"});
        }

        try {
          await this.GetFlightNotes(this.activeLegNo);
          this.FlightNotifyDetails = JSON.parse(
            this.FlightNoteList.filter((x) => x.ntype == "T")[0].message
          );
        } catch (e) {
          console.log("GetFlightNotes JSON.parse -> this.FlightNoteList" + e);
        }

        this.writtenFlightNote = "";
      }
    },

    async hideFlightNoteModal() {
      let errline = "";
      console.log(errline);
      try {
        errline = "closeFlightNoteModal";
        await this.closeFlightNoteModal();

        errline = "showLoading";
        this.showLoading();

        errline = "getScheduleFlights";
        // await this.getScheduleFlights();

        errline = "hideLoading";
        this.hideLoading();
      } catch (e) {
        //this.$notify({title: "Error", text:" hideFlightNoteModal "+errline+e.message, type: "error"});
      }
    },
  },

  async created() {
    this.flightNoteActiveLegNo = this.activeLegNo;
  },
};
</script>

<style>
.close-btn {
  font-size: 18px;
  background: transparent;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: #f3f4f6;
  color: #111827;
}

.message-button {
  border: none;
  background-color: #455f83;
  color: #fff;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}

.modal-content {
  border-radius: 16px;
  width: 90%;
  max-width: 1000px;
  height: 70vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin: 5vh auto;
}

.modal-header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 20px 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.flight-info {
  font-size: 18px;
  color: #555;
}
</style>
